// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `g.nodes {
  cursor: pointer;
  stroke-width: 4px;
}

.circleDisabled {
  fill-opacity: 0.1;
  stroke: transparent;
  stroke-width: 0.1px;
  stroke-opacity: 0.1 !important;
}

.linkActive {
  stroke-width: 0.5;
}

text {
  fill-opacity: 1;
  font-family: "IliaMontSerrat";
  font-weight: 800;
  cursor: pointer;
}

#svg-map {
  touch-action: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/career-map/workbanck.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,iBAAA;AACJ;;AAGA;EACI,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AAAJ;;AAGA;EACI,iBAAA;AAAJ;;AAIA;EACI,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;AADJ;;AAIA;EACI,kBAAA;AADJ","sourcesContent":["g.nodes {\n    cursor: pointer;\n    stroke-width: 4px;\n   \n}\n\n.circleDisabled {\n    fill-opacity: 0.1;\n    stroke: transparent;\n    stroke-width: 0.1px;\n    stroke-opacity: 0.1 !important;\n}\n\n.linkActive {\n    stroke-width: 0.5;\n}\n\n\ntext {\n    fill-opacity: 1;\n    font-family: \"IliaMontSerrat\";\n    font-weight: 800;\n    cursor: pointer;\n}\n\n#svg-map{\n    touch-action: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
